<template>
	<div id="group-create-tab-info">
		<bread-crumbs
			class="ml-1"
			:title="
				group_local.id > 0
					? $t('Crud.Update') + ' ' + $t('Groups.Group')
					: $t('Crud.Create') + ' ' + $t('New') + ' ' + $t('Groups.Group')
			"
			:subTitle="group_local.id > 0 ? $t('general.SubtitleGroupsUpdate') : $t('general.SubtitleGroupsCreate')"
			:sizeTitle="22"
			:lineHeightTitle="27"
			:sizeSubTitle="13"
			:lineHeightSubTitle="16"
		>
		</bread-crumbs>
		<div class="vx-row mb-2">
			<div class="vx-col w-full flex items-center">
				<feather-icon
					class="g-breadcrumb--title"
					icon="ChevronLeftIcon"
					svgClasses="h-8 w-8"
					@click.prevent="$emit('valueFormGroup', 0)"
				/>
				<vs-breadcrumb
					class="g-breadcrumb--title"
					separator=""
					:items="[{title: $t('general.Return')}]"
					@click.prevent="$emit('valueFormGroup', 0)"
				></vs-breadcrumb>
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full md:w-3/5">
				<vx-card>
					<vs-navbar :type="'gradient'" v-model="activeNavItem" class="nabarx mb-2">
						<div slot="title">
							<vs-navbar-title>
								<span class="g-tools--description">{{ navbarTitle }}</span>
							</vs-navbar-title>
						</div>
						<vs-navbar-item :index="0">
							<div class="flex flex-col items-center justify-center">
								<vx-tooltip
									style="z-index: 99999"
									:title="$t('Information')"
									color="primary"
									position="bottom"
									:text="`${$t('Information')}: ${$t('Resource.PrincipalProperties')}, ${$t(
										'Resource.AdditionalProperties'
									)}`"
								>
									<vs-icon icon="info" size="medium" class="cursor-pointer"></vs-icon>
								</vx-tooltip>
								<small :class="activeNavItem === 0 ? 'g-label text-white' : ''">
									{{ $t("Information") }}
								</small>
							</div>
						</vs-navbar-item>
						<vs-navbar-item :index="1">
							<div class="flex flex-col items-center justify-center">
								<vx-tooltip
									style="z-index: 99999"
									:title="$t('Resource.AssigResources')"
									color="primary"
									position="bottom"
									:text="$t('Resource.AssignResourceToltip')"
								>
									<vs-icon icon="person" size="medium" class="cursor-pointer"></vs-icon>
								</vx-tooltip>
								<small :class="activeNavItem === 1 ? 'g-label text-white' : ''">
									{{ $t("Resource.AssigResources") }}
								</small>
							</div>
						</vs-navbar-item>
					</vs-navbar>
					<form v-if="activeNavItem === 0" class="form-content mt-4">
						<vs-row vs-w="12">
							<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<!-- NAME -->
										<label class="g-object--description" v-text="$t('Name')"></label>
										<vs-input
											v-model="group_local.name"
											class="w-full"
											name="item-name"
											v-validate="'required'"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('item-name')"
											v-text="$t('GroupValidMessages.ItemName')"
										></span>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<label class="g-object--description" v-text="$t('Address')"></label>
										<vx-input-group>
											<vs-input
												v-model="group_local.address"
												class="w-full"
												name="item-address"
												v-validate="'required'"
												@change="update ? (showGeoAgaing = true) : ''"
											/>
											<template v-if="showGeoAgaing" slot="append">
												<div class="append-text btn-addon">
													<vx-tooltip
														class="cursor-pointer"
														style="z-index: 9999"
														color="primary"
														position="top"
														:title="$t('MapModule.GeoAgain')"
														:text="$t('MapModule.GeoSub')"
													>
														<vs-button
															icon-pack="feather"
															icon="icon-globe"
															@click.prevent="geoCoder"
														></vs-button>
													</vx-tooltip>
												</div>
											</template>
										</vx-input-group>
										<span class="text-danger text-sm" v-show="errors.has('item-address')"
											>{{ $t("GroupValidMessages.ItemAddress") }}
										</span>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<label class="g-object--description" v-text="$t('Country')"></label>
										<v-select
											v-model="selectedCountry"
											name="country"
											v-validate="'required'"
											:clearable="false"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:options="countriesOptions"
											:disabled="
												group_local.address === '' ||
												group_local.address === null ||
												group_local.address === undefined
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('country')"
											>{{ $t("VisitPointObject.Create.ValidMessages.Country") }}
										</span>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<label class="g-object--description">{{
											getPoliticalDivision.department
										}}</label>
										<v-select
											v-model="selectedDepartment"
											name="departments"
											:clearable="false"
											:options="departments"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:loading="
												departments.length <= 0 && selectedCountry.value != '' ? true : false
											"
											:disabled="
												departments.length <= 0 ||
												group_local.address === '' ||
												group_local.address === null ||
												group_local.address === undefined
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('departments')">{{
											$t("ValidateField", {n: getPoliticalDivision.department.toLowerCase()})
										}}</span>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<label class="g-object--description">{{ getPoliticalDivision.city }}</label>
										<v-select
											v-model="dataCity"
											name="cities"
											v-validate="'required'"
											:clearable="false"
											:options="cities"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:loading="
												cities.length <= 0 && selectedDepartment && selectedCountry.value != ''
													? true
													: false
											"
											:disabled="
												cities.length <= 0 ||
												group_local.address === '' ||
												group_local.address === null ||
												group_local.address === undefined
											"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
											</template>
										</v-select>
										<span class="text-danger text-sm" v-show="errors.has('cities')">{{
											$t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()})
										}}</span>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full md:w-1/2">
										<label class="g-object--description" v-text="$t('InitHour')"></label>
										<flat-pickr
											:config="configdateTimePicker"
											class="w-full"
											v-model="group_local.hour_init"
											placeholder="Selection init time"
											v-validate="'init_hour'"
											name="dataHourInit"
										/>
										<span
											class="text-danger text-sm"
											v-show="errors.has('dataHourInit')"
											v-text="$t('Alarm.ValidInitHour')"
										></span>
									</div>
									<div class="vx-col w-full md:w-1/2">
										<label class="g-object--description" v-text="$t('EndHour')"></label>
										<flat-pickr
											:config="configdateTimePicker"
											v-model="group_local.hour_end"
											class="w-full"
											placeholder="Selection end time"
											v-validate="'truthy'"
											name="dataHourEnd"
										/>
										<span class="text-danger text-sm" v-show="errors.has('dataHourEnd')">{{
											$t("Schedule.ValidEndOur")
										}}</span>
									</div>
								</div>
								<div class="vx-row mb-4">
									<div class="vx-col w-full">
										<label class="g-object--description" v-text="$t('Description')"></label>
										<vs-textarea
											name="item-description"
											v-model="group_local.description"
											class="w-full"
											rows="3"
										/>
										<span class="text-danger text-sm" v-show="errors.has('item-description')">{{
											$t("CompanyForm.descriptionRequired")
										}}</span>
									</div>
								</div>
							</vs-col>
						</vs-row>
					</form>
					<div v-if="activeNavItem === 1" class="mt-6">
						<resource-assigned-list
							:resource_ids="group_local.resource_id"
							:search="true"
							:pagination="true"
						></resource-assigned-list>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-2/5">
				<vx-card>
					<div class="vx-row">
						<div class="vx-col md:w-1/2 w-full">
							<label class="g-label" v-text="$t('MapModule.Latitude')"></label>
							<vs-input class="w-full mb-4" v-model="group_local.cy" name="cy" disabled />
							<span
								class="text-danger text-sm"
								v-show="errors.has('cy')"
								v-text="errors.first('cy')"
							></span>
						</div>
						<div class="vx-col md:w-1/2 w-full">
							<label class="g-label" v-text="$t('MapModule.Longitude')"></label>
							<vs-input class="w-full mb-4" v-model="group_local.cx" name="cx" disabled />
							<span
								class="text-danger text-sm"
								v-show="errors.has('cx')"
								v-text="errors.first('cx')"
							></span>
						</div>
					</div>
					<div class="map-custom-container">
						<here-map
							name="theMap"
							ref="moduleMap"
							latitude="4.686699"
							longitude="-74.0837187"
							zoom="13"
							:width="widthMap"
							height="90vh"
							theme="uber"
							calledFrom="calendar"
							@geoInversoEmit="geoInverso"
						></here-map>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-full md:w-3/3">
				<div class="mt-4 flex flex-wrap items-center justify-end">
					<vs-button
						class="mr-6 g-btn--resourcePopup"
						type="border"
						color="danger"
						@click="$emit('valueFormGroup', 0)"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						id="btn-submit-group"
						class="vs-con-loading__container g-btn--resourcePopup"
						color="success"
						@click="submitData"
						:disabled="!isFormValid"
						>{{ $t("Save") }}
					</vs-button>
				</div>
			</div>
			<vs-prompt title="" :active.sync="activePrompt" @cancel="close" @accept="acceptAlert" @close="close">
				<div class="con-exemple-prompt">
					<p>
						{{ $t("VisitPointObject.Create.GeoFindNextAddress") }}
					</p>
					<vs-input
						placeholder="Code"
						vs-placeholder="Code"
						v-model="dataGeo.address1"
						class="mt-3 w-full mb-4"
					/>
					<p>{{ $t("VisitPointObject.Create.UseAddressQuestion") }}</p>
				</div>
			</vs-prompt>
		</div>
	</div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import moduleGroup from "@/store/group/moduleGroup.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleResource from "@/store/resource/moduleResource.js";
import Group from "@/models/Group.js";
import Commons from "@/helpers/commons.js";
import {Validator} from "vee-validate";
import HereMap from "@/components/Maps/Maps";
import {clearMap} from "@/utils/HereMap";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import ResourceAssignedList from "@/components/resource/user-list/ResourceAssignedList";
import {politicalDivisionMixin} from "@/mixins/politicalDivisionMixin.js";

export default {
	mixins: [politicalDivisionMixin],
	props: {
		data: {
			type: Group,
			default: () => {
				new Group({});
			},
		},
	},
	components: {
		ResourceAssignedList,
		HereMap,
		flatPickr,
		vSelect,
	},
	data() {
		return {
			group_local: new Group({}),
			dataCity: null,
			selectedDepartment: null,
			departments: [],
			countries: [],
			cities: [],
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			dataGeo: {
				dirtrad: "",
				status: "",
				latitude: "",
				longitude: "",
			},
			activeNavItem: 0,
			update: false,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			showGeoAgaing: false,
			activePrompt: false,
		};
	},
	computed: {
		isFormValid() {
			return !this.errors.any() && this.group_local.name.length > 0 && this.group_local.address.length > 0;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		countriesOptions() {
			return Commons.generateSelectOptios(
				this.$store.state.moduleCommon.countries_sitidata,
				"country_name",
				"country_name"
			);
		},
		assignedResources() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Information");
			else return this.$t("Resource.AssigResources");
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		widthMap() {
			let widthValue = "";
			if (this.$store.state.reduceButton && this.windowWidth > 600) {
				widthValue = "33vw";
			} else if (this.windowWidth > 600) {
				widthValue = "25vw";
			} else if (this.windowWidth < 600) {
				widthValue = "100%";
			}
			return widthValue;
		},
		selectedCountry: {
			get() {
				return {
					label: this.group_local.country === undefined ? "" : this.group_local.country,
					value: this.group_local.country === undefined ? "" : this.group_local.country,
				};
			},
			set(obj) {
				this.selectedDepartment = {};
				this.selectedCity = {};
				this.group_local.country = obj.label;
				this.getDepartments(obj.label);
			},
		},
	},
	methods: {
		initValues() {
			this.selectedCountry = null;
			this.dataCity = null;
		},
		submitData() {
			if (this.group_local.hour_init === "" && this.group_local.hour_end === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("TitleConfirmGroupUpdate"),
					text: this.$t("TextConfirmGroupUpdate"),
				});
				return;
			}
			this.$validator.validate().then((valid) => {
				if (valid) {
					if (this.group_local.id > 0) {
						//  update
						this.updateGroup();
					} else {
						//  create
						this.createGroup();
					}
				}
			});
		},
		createGroup() {
			const ids = this.assignedResources.map((r) => r.id);
			this.group_local.resource_id = ids;
			delete this.group_local.id;
			Commons.openLoadingButton.call(this, "btn-submit-group");
			this.$store
				.dispatch("moduleGroup/createGroup", this.group_local)
				.then((res) => {
					this.$emit("closeSidebar");
					this.initValues();
					setTimeout(() => {
						this.errors.clear();
					}, 50);
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmGroupCreate"),
						text: this.$t("TextConfirmGroupCreate"),
					});
					Commons.closeLoadingButton.call(this, "btn-submit-group");
					this.$emit("valueFormGroup", 0);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-submit-group");
					throw new Error(err);
				});
		},
		updateGroup() {
			const ids = this.assignedResources.map((r) => r.id);
			this.group_local.resource_id = ids;
			Commons.openLoadingButton.call(this, "btn-submit-group");
			this.$store
				.dispatch("moduleGroup/updateGroup", this.group_local)
				.then((res) => {
					this.$emit("closeSidebar");
					this.$emit("valueFormGroup", 0);
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmGroupUpdate"),
						text: this.$t("TextConfirmGroupUpdate"),
					});
					Commons.closeLoadingButton.call(this, "btn-submit-group");
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-submit-group");
					throw new Error(err);
				});
		},
		/**
		 * @param{String} stringTime 01:00:45
		 */
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		getCities(departmentName) {
			this.$store
				.dispatch("moduleCommon/getCitiesByDeparment", {
					name: departmentName,
					country: this.group_local.country,
				})
				.then((res) => {
					this.cities = Commons.generateSelectOptios(res.data, "city_name", "city_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		getDepartments(countryName) {
			this.$store
				.dispatch("moduleCommon/getDepartments", {name: countryName})
				.then((res) => {
					this.departments = Commons.generateSelectOptios(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					throw new Error(error);
				});
		},
		validateEndHour(value, args) {
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.group_local.hour_init);
		},
		validateInitHour(value, args) {
			if (value === "") {
				return false;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.group_local.hour_end);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		geoInverso({country, cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {country, cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					if (res.data.address1 !== this.group_local.address) {
						this.activePrompt = true;
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPointObject.Create.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPointObject.Create.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		geoCoder() {
			const {country, city, address, department} = this.group_local;
			if ((address === null || address === undefined || address === "") && this.data.id === 0) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPointObject.Create.MissingAddress.Title"),
					text: this.$t("VisitPointObject.Create.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("MapModule.Georeferencer"),
							text: this.$t("ManualData.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}
					if (res.status === 200 && res.message === "Geocodificacion Exitosa.") {
						clearMap();
						this.dataGeo = {...res.data};
						this.group_local.cy = parseFloat(this.dataGeo.latitude);
						this.group_local.cx = parseFloat(this.dataGeo.longitude);
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPointObject.Create.FindAddress.Title"),
								text: this.$t("VisitPointObject.Create.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.$refs.moduleMap.addMarkerVisitPoint(this.group_local);
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
								text: this.$t("VisitPointObject.Create.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		acceptAlert() {
			this.selectedCountry.label = this.dataGeo.country_long_name;
			this.group_local.country = this.dataGeo.country_long_name;
			this.group_local.address = this.dataGeo.address1;
			this.selectedDepartment = this.dataGeo.department1;
			this.dataCity = this.dataGeo.city1;
			this.group_local.department = this.dataGeo.department1;
			this.group_local.city = this.dataGeo.city1;
		},
		close() {
			this.dataGeo.address1 = "";
			this.geoCoder();
		},
	},
	watch: {
		dataCity(val) {
			if (val) {
				this.group_local.city = typeof val === "object" ? val.value : val;
				if (!this.update) this.geoCoder();
			}
		},
		selectedDepartment(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.group_local.department = typeof val === "object" ? val.value : val;
			this.getCities(val.value);
		},
		"group_local.hour_end"(val) {
			this.errors.clear();
			setTimeout(() => {
				this.validateInitHour(this.group_local.hour_init);
			}, 50);
		},
		"group_local.hour_int"(val) {
			this.errors.clear();
			setTimeout(() => {
				this.validateEndHour(this.group_local.hour_end);
			}, 50);
		},
	},
	created() {
		// register Module Group
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
		// register Module Common
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries_sitidata.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountriesByTokenSitiData")
				.then((res) => {
					if (res.data.length === 1 && !this.update) {
						this.selectedCountry = res.data[0]["country_name"].toUpperCase();
					}
				})
				.catch((error) => {
					throw new Error(error);
				});
		}
		Validator.extend("truthy", this.validateEndHour);
		Validator.extend("init_hour", this.validateInitHour);
		new Validator({trueField: "truthy"}, {trueField: "init_hour"});
	},
	mounted() {
		if (this.data.id === 0) {
			this.$validator.reset();
			this.initValues();
		} else {
			this.update = true;
			this.selectedCountry = this.data.country.toUpperCase();
			this.dataCity = this.data.city;
			this.selectedDepartment = this.data.department;
			this.openLoading();
			this.$store
				.dispatch("moduleGroup/fetchGroupItems", {
					ids: [this.data.id],
				})
				.then((res) => {
					if (res.records.length > 0) {
						this.group_local = new Group(res.records[0]);
						setTimeout(() => {
							this.$refs.moduleMap.addMarkerVisitPoint(this.group_local);
						}, 1000);
						let payload = {
							ids: this.group_local.resource_id,
							fields: ["id", "name", "lastname", "username", "identification", "email"],
						};
						if (payload.ids.length > 0) {
							return this.$store.dispatch("moduleResource/getResourcesByFilter", payload);
						} else {
							return {data: {records: []}};
						}
					}
				})
				.then((res) => {
					this.assignedResourcesList = res.data.records;
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		}
	},
	beforeDestroy() {
		this.showGeoAgaing = false;
		this.$store.dispatch("moduleResource/cleanResourceActivity");
	},
};
</script>

<style lang="scss" scoped>
#group-create-tab-info {
	height: 100%;
}

.group-create-tab-info--form {
	height: 200px;
}

.scroll-area {
	margin: 5px;
	min-height: 253px;
	max-height: 308px;
}

.col-resource:nth-child(2) {
	flex-grow: 4;
}

.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
